import Svg, { SvgProps } from './Svg';

export default function SparkLiquidityLayerIcon({ ...props }: SvgProps) {
  const id1 =
    'linearGradient-liquiditylayer' + Math.random().toString(16).slice(2);
  return (
    <Svg viewBox="0 0 96 96" fill="none" {...props}>
      <path
        d="M0.256109 6.22786L28.5505 48L0.256109 89.7722C-0.621569 91.0679 0.935205 92.6226 2.22874 91.7425L66.502 48.0025L50.9941 90.0783C50.4676 91.5066 52.2527 92.6496 53.3287 91.5731L95.3765 49.5052C96.2078 48.6735 96.2078 47.3252 95.3765 46.4938L53.3287 4.42569C52.2527 3.34913 50.4676 4.49235 50.9941 5.92072L66.5027 47.9981L2.22874 4.25759C0.935205 3.37729 -0.621569 4.93217 0.256109 6.22786Z"
        fill={`url(#${id1})`}
      />
      <defs>
        <linearGradient
          id={id1}
          x1="103.632"
          y1="47.9994"
          x2="0.0133282"
          y2="47.9994"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C51FDB" />
          <stop offset="1" stopColor="#FF82DE" />
        </linearGradient>
      </defs>
    </Svg>
  );
}
